<template>
  <div class="ui-events-list">
    <div v-if="isLoading" class="ui-events-list__box">
      <p class="ui-events-list__label ui-events-list__label--search">Поиск...</p>
    </div>

    <ui-events-list-item
      v-else-if="events.length"
      v-for="(event, index) in events"
      :key="event.id + index"
      :item="event"
      :form="form"
    />

    <div v-else class="ui-events-list__box">
      <p class="ui-events-list__label">Не удалось найти подходящего мероприятия</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import UIEventsListItem from './events-list-item.vue'

export default {
  name: 'ui-events-list',
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  components: {
    'ui-events-list-item': UIEventsListItem,
  },
  computed: {
    ...mapState('events', {
      isLoading: state => state.isLoading,
    }),
    ...mapGetters('events', {
      events: 'getListEvents',
    }),
  },
}
</script>

<style lang="sass">
.ui-events-list
  display: flex
  flex-direction: column

  &__box
    background: white
    padding-inline: 32px
    display: flex
    height: 48px
    align-items: center
    border-radius: 4px

  &__label
    font-size: 18px
    font-weight: 600

    &--search
      animation-name: loader
      animation-duration: 1s
      animation-iteration-count: infinite

@keyframes loader
  0%,
  100%
    opacity: 1
  50%
    opacity: 0.1
</style>



// WEBPACK FOOTER //
// src/templates/pages/events/components/events-list/events-list.vue